export const SET_LINKS = "SET_LINKS";
export const ADD_LINK = "ADD_LINK";
